<template>
  <div class="plp-page-wrapper">
    <AlgoliaCSR :filter-by-starter="state.filterByStarter" :plp="state.plp" render-mode="plp" />
  </div>
</template>

<script setup lang="ts">
import { QueryTypes } from '~/server/utils/contentstack';
import { metaGen } from '~/util/metadata';
import { contentstackRequest } from '~/util/contentstack/api';
import { getFirstIndex } from '~/util/arrays';
import { useRootStore } from '~/store';
// import { DyPreOrganizedData } from '~/composables/dy-fetch';

// declare global {
//   interface Window {
//     __NUXT__: any;
//   }
// }

const event = useRequestEvent();
const config = useRuntimeConfig();
const rootStore = useRootStore();
const route = useRoute();
const { $bus }: any = useNuxtApp();
const { locale } = useI18n();

const { data: asyncData, error: asyncError } = await useAsyncData(async () => {
  const contentStackData = await contentstackRequest(QueryTypes.plp, `/plp/${route.params.listing}`, {
    event,
    query: {
      locale: locale?.value,
    },
  });
  // console.log('PLP CTS DATA', contentStackData)
  if (!contentStackData) throw createError({ statusCode: 404, message: 'Page not found' });

  // On plp, pages can be empty
  const plp = getFirstIndex(contentStackData?.data?.all_product_landing_page?.items);

  if (!plp) throw createError({ statusCode: 404, message: 'Page not found' });

  const listingUrl = (route?.params?.listing as string) || '';
  let filterString: any = listingUrl.split('-');

  filterString.forEach((part: string, i: number) => {
    if (part.length > 1) filterString[i] = part[0].toUpperCase() + part.slice(1);
    if (part.length === 1) filterString[i] = part.toUpperCase();
  });
  filterString = filterString.join(' ');

  // if (process.server) {
  //   const event = useRequestEvent();
  //   const title = plp?.display_title || plp?.title || '';
  //   const data: DyPreOrganizedData = {
  //     pageType: 'CATEGORY',
  //     pageData: [title],
  //   };
  //   await dyChooseWithEvent(event, data);
  // }

  return {
    plp,
    listingUrl,
    filterByStarter: (filterString && `categories:'${filterString}'`) || '',
  };
});

useAsyncErrorHandling({
  error: asyncError.value,
});

const metaGenCustom = metaGen(rootStore?.brandSettings, {
  ...(asyncData.value?.plp?.seo || {}),
}) as any;
// https://www.algolia.com/doc/guides/building-search-ui/going-further/improve-performance/vue/
metaGenCustom.link.push({
  href: `https://${config.public.algoliaAppId}-dsn.algolia.net`,
  crossorigin: true,
  rel: 'preconnect',
});

useHead({
  ...metaGenCustom,
});

const state = reactive({
  plp: asyncData.value?.plp || ({} as any),
  listingUrl: asyncData.value?.listingUrl || '',
  filterByStarter: (asyncData.value?.filterByStarter || '') as string,
});

// const displaySections = computed(() => {
//   return state.plp?.sections;
// });
const plpTitle = computed(() => {
  return state.plp?.display_title || state.plp?.title || '';
});

onMounted(() => {
  $bus.emit('pageView', {
    url: document.URL,
    data: {
      pageType: 'PLP',
      category: [plpTitle.value],
      referrerURL: document.referrer || '',
      // noOfTiles: this.instantsearch?.helper?.lastResults?.nbHits || '', // TODO - Find
      // a better solution to this - Not stable
    },
  });
});
</script>

<style lang="scss" scoped>
.plp-page-wrapper {
  @include local-mixins.tablet_and_mobile {
    margin-top: 1.5rem;
  }
}
</style>
